// custom locales for dateLabel
const locales = {
    'zh-hant': {
        meridiem: (hour) => (hour > 12 ? '下午' : '上午'),
    },
    'zh-cn': {
        meridiem: (hour) => (hour > 12 ? '下午' : '上午'),
    },
    en: {},
    vi: {},
    th: {},
};
export default locales;
//# sourceMappingURL=locales.js.map